export const LOCAL_STORAGE = {
  CAVALLINO_TOKEN: 'cavallinoToken',
  CAVALLINO_SUBSCRIPTION: 'cavallinoSub',
  FIRST_LOGIN: 'first_login'
};
